import { derivative, simplify, type ExprNode } from '@learnforge/demo-math/expr';

export function formalDerivative(node: ExprNode): ExprNode {
  const d = derivative(node, 'x');
  try {
    return simplify(d);
  } catch {
    return d;
  }
}
